import { Component, OnInit, Inject, ViewChild, AfterViewInit, ElementRef, OnDestroy } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { serviceUrl } from '../common/serviceconstants';
import { Router, ActivatedRoute } from '@angular/router';
import { GenericHttpClient } from '../Services/Basicauthentication';
import { UtilityServices } from '../UtilityServices';
import { CurrencyPipe } from '@angular/common'
import { ThrowStmt } from '@angular/compiler';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';


@Component({
  selector: 'app-project-management',
  templateUrl: './project-management.component.html',
  styleUrls: ['./project-management.component.scss']
})
export class ProjectAcquisitionComponent implements OnInit, OnDestroy {
  pfiscalyear: any = '';
  isfutureexists: any = false;
  isfuture: any = false;
  projectnumber: any = '';
  projectname: any = '';
  projectcategory: any = '';
  projectcattype: any = '0';
  projectcattypes: any = [];
  projectsubcategoriestype: any = '0';
  projectsubcategoriestypes: any = [];
  projectstatus: any = '0';
  projectstatustypes: any = [];
  pbudgetamount: any = '0.00';
  pactuals: any = '0.00';
  pamtencumbered: any = '0.00';
  premainingbalance: any = '0.00';
  amountsdisable = true;
  pcomment: any = '';
  ISSHOW: any = false;
  adocumentname: any;
  ispublicAccessible: any = false;
  dmessage: any;
  pmessage: any;
  id: any = 0;
  adocauthor: any = '';
  Message = '';
  Action: any = 'ADD'
  projinfo: any;
  userid: any;
  constructor(private http: HttpClient, private router: Router, private httpClient: GenericHttpClient,
    private utility: UtilityServices, private cp: CurrencyPipe) {
    const userid = sessionStorage.getItem('UserID');
    if (userid === '' || userid === null) {


    } else {
      // this.IsAdmin = true;
      this.userid = userid;
    }
    // this.getprojectamounts();
    let a = sessionStorage.getItem("Admin");
    if (a && a === "True") {
      this.isadmin = true;
    } else {
      this.router.navigateByUrl('/dashboard');
    }
    this.setprojdetails();
    this.GetProjectCategoryTypes();
    this.GetProjectSubCategoryTypes();
    this.GetProjectStatusTypes();
    this.getprojectdocumentallinfo();


  }

  ngOnDestroy(): void {
    sessionStorage.removeItem('projinfo')
  }
  PublishedProject: any = false;
  isfuturechange() {
    if (this.isfuture) {
      this.ClearProjectInfo();
      this.projectstatus = "Not Started";
      this.projectsubcategoriestype = "0";
    }
    else {
      this.projectstatus = "0";
    }
  }
  setprojdetails() {

    let item = sessionStorage.getItem('projinfo');
    if (item) {
      this.Action = "UPDATE";
      //console.log(item);
      this.projinfo = JSON.parse(item);
      this.id = this.projinfo.ID;
      this.pfiscalyear = this.projinfo.FiscalYear;
      this.projectnumber = this.projinfo.ProjectNumber;
      this.projectname = this.projinfo.ProjectName;
      this.PublishedProject = this.projinfo.PublishedProject;
      // this.projectcattype = this.projinfo.ProjectCategory;
      // this.projectsubcategoriestype = this.projinfo.ProjectSubCategory;
      // this.projectstatus = this.projinfo.ProjectStatus;
      // this.pbudgetamount = this.projinfo.CIPBudgetAmount;
      // this.pamtencumbered = this.projinfo.AmountEncumbered;
      // this.premainingbalance = this.projinfo.RemainingBalance;
      this.pcomment = this.projinfo.Comments;
      this.getprojectamounts();
      //this.pactuals = this.projinfo.Actuals;

    }
  }
  pbudgetamounttemp: any = 0.00;
  futurebudget() {
    this.pbudgetamounttemp = this.pbudgetamount;
    this.pbudgetamount = this.cp.transform(this.pbudgetamount, 'USD', 'symbol', '1.2-2')
  }

  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  ngOnInit(): void {
  }

  GetProjectCategoryTypes(): void {
    this.httpClient.get(serviceUrl + '/Project/GetProjectCategoryTypes',
      '').toPromise<any>().then(response => {
        this.projectcattypes = response;
        if (this.projinfo) {
          setTimeout(() => { this.projectcattype = this.projinfo.ProjectCategory; }, 200);
        }
      });
  }

  GetProjectSubCategoryTypes(): void {
    this.httpClient.get(serviceUrl + '/Project/GetProjectSubCategoryTypes',
      '').toPromise<any>().then(response => {
        this.projectsubcategoriestypes = response;
        if (this.projinfo) {
          setTimeout(() => { this.projectsubcategoriestype = this.projinfo.ProjectSubCategory; }, 300);
        }
      });
  }

  GetProjectStatusTypes(): void {
    this.httpClient.get(serviceUrl + '/Project/GetProjectStatusTypes',
      '').toPromise<any>().then(response => {
        this.projectstatustypes = response;
        if (this.projinfo) {
          setTimeout(() => {
            this.projectstatus = this.projinfo.ProjectStatus;
            if (this.projectstatus === "Not Started") {
              this.isfuture = true;
              let item: any = sessionStorage.getItem('projinfo');
              // console.log(item);
              if (item) {
                let data: any = JSON.parse(item);
                this.projectname = data.ProjectName;
              }
            }
          }, 200);
        }
      });
  }

  displayedColumns: string[] =
    [
      'DocumentName',
      'FileName',
      'DocumentAuthor',
      'PublicAccess',
      'Update',
      'Delete'
    ];

  ngAfterViewInit(): void {
    this.DocsdataSource.sort = this.sort;
    this.DocsdataSource.paginator = this.paginator;
  }


  SaveProjectInfo() {
    if (this.isfuture) {
      if (this.pfiscalyear && this.pfiscalyear.length > 0 &&

        this.projectname && this.projectname.length > 0 &&
        // this.projectcattype && this.projectcattype.length > 0 && this.projectcattype != "0" &&
        this.projectsubcategoriestype && this.projectsubcategoriestype.length > 0 && this.projectsubcategoriestype != "0" &&
        this.projectstatus && this.projectstatus.length > 0 && this.projectstatus != "0") {
        const hdrs = new HttpHeaders(
          { 'Content-type': 'application/json' });
        this.http.post<any>(serviceUrl + '/Project/InsertProjectInfo', {
          FiscalYear: this.pfiscalyear,
          ProjectNumber: this.projectnumber,
          ProjectName: this.projectname,
          ProjectCategory: this.projectcattype,
          ProjectSubCategory: this.projectsubcategoriestype,
          ProjectStatus: this.projectstatus,
          CIPBudgetAmount: this.pbudgetamounttemp,
          Actuals: 0.00,
          AmountEncumbered: 0.00,
          RemainingBalance: 0.00,
          Comments: this.pcomment,
          ID: this.id,
          ModifiedBy: this.userid,
          PublishedProject: this.PublishedProject
        }, { headers: hdrs }).subscribe(
          res => {
            //this.ClearProjectInfo();
            if (res !== 0)
              this.id = res;
            this.pmessage = 'Project Successfully saved.';

          },
          err => {


          });
      } else {
        this.pmessage = 'Please enter required fields.';
      }

    } else {
      if (this.projmessage !== "Duplicate Project Number!") {
        if (this.pfiscalyear && this.pfiscalyear.length > 0 &&
          this.projectnumber && this.projectnumber.length > 0 &&
          this.projectname && this.projectname.length > 0 &&
          // this.projectcattype && this.projectcattype.length > 0 && this.projectcattype != "0" &&
          this.projectsubcategoriestype && this.projectsubcategoriestype.length > 0 && this.projectsubcategoriestype != "0" &&
          this.projectstatus && this.projectstatus.length > 0 && this.projectstatus != "0") {
          const hdrs = new HttpHeaders(
            { 'Content-type': 'application/json' });
          this.http.post<any>(serviceUrl + '/Project/InsertProjectInfo', {
            FiscalYear: this.pfiscalyear,
            ProjectNumber: this.projectnumber,
            ProjectName: this.projectname,
            ProjectCategory: this.projectcattype,
            ProjectSubCategory: this.projectsubcategoriestype,
            ProjectStatus: this.projectstatus,
            CIPBudgetAmount: this.projamounts.CIPBudgetAmount,
            Actuals: this.projamounts.Actuals,
            AmountEncumbered: this.projamounts.AmountEncumbered,
            RemainingBalance: this.projamounts.RemainingBalance,
            Comments: this.pcomment,
            ID: this.id,
            ModifiedBy: this.userid,
            PublishedProject: this.PublishedProject
          }, { headers: hdrs }).subscribe(
            res => {
              //this.ClearProjectInfo();
              if (res !== 0)
                this.id = res;
              this.pmessage = 'Project Successfully saved.';

            },
            err => {


            });
        } else {
          this.pmessage = 'Please enter required fields.';
        }
      }
      else {
        this.pmessage = "Project already exists!"
      }
    }
  }

  cDocsData: any = [];
  cdocsvisible: any = false;
  DocsdataSource: any = [];
  isadmin: any = false;

  getprojectdocumentallinfo() {
    this.http.get(serviceUrl + '/ProjectDocuments/GetProjectDocs',
      { params: { projnumber: this.id, isadmin: this.isadmin } }).toPromise<any>().then(response => {
        this.cDocsData = response;
        this.DocsdataSource = new MatTableDataSource(response);
        if (this.cDocsData.length > 0) {
          this.cdocsvisible = true;

        }
      });
  }

  CloseProjectInfo() {
    this.router.navigateByUrl('/dashboard');
  }

  ClearProjectInfo() {
    this.pfiscalyear = '';
    this.projectname = '';
    this.projectnumber = '';
    this.projectcategory = '';
    this.projectsubcategoriestype = '';
    if (!this.isfuture) {
      this.projectstatus = '';
    }

    this.pbudgetamount = '0.00';
    this.pactuals = '0.00';
    this.pamtencumbered = '0.00';
    this.premainingbalance = '0.00';
    this.pcomment = '';
    this.pmessage = '';
    this.projmessage = '';

  }
  docprojname: any = "";
  NextInfo() {
    this.ISSHOW = true;
    if (this.projectname && this.projectname.length > 0) {
      this.docprojname = this.projectnumber + ' - ' + this.projectname;
      this.getprojectdocumentallinfo();
    } else {
      this.docprojname = '';
    }
  }
  Previousdocs() {
    this.ISSHOW = false;
  }




  projamounts: any;
  projmessage: any = '';
  getprojectamounts(): void {
    this.projmessage = "";
    this.httpClient.get(serviceUrl + '/Project/GetProjectAmounts',
      { projnumber: this.projectnumber }).toPromise<any>().then(response => {
        if (response && response.ProjectName && response.ProjectName.length > 0) {
          if (this.Action === 'ADD') {
            this.id = 0;
          }
          this.projamounts = response;
          this.projectname = response.ProjectName;
          this.pbudgetamount = this.cp.transform(response.CIPBudgetAmount, 'USD', 'symbol', '1.2-2');
          this.pactuals = this.cp.transform(response.Actuals, 'USD', 'symbol', '1.2-2');
          this.pamtencumbered = this.cp.transform(response.AmountEncumbered, 'USD', 'symbol', '1.2-2');
          this.premainingbalance = this.cp.transform(response.RemainingBalance, 'USD', 'symbol', '1.2-2');
          this.amountsdisable = true;
          this.projmessage = response.isprojectexists && this.Action === 'ADD' ? "Duplicate Project Number!" : "";
        } else {
          this.projmessage = "Invalid Project Number!";
          this.projectname = '';
          this.pbudgetamount = '0.00';
          this.pactuals = '0.00';
          this.pamtencumbered = '0.00';
          this.premainingbalance = '0.00';
        }
      });
  }

  @ViewChild('file', { static: false }) myInputVariable: ElementRef;

  acdclear() {
    this.adocumentname = '';
    this.afilename = '';
    this.fileToUpload = null;
    this.filemessage = '';
    this.dmessage = '';
    this.ispublicAccessible = false;
    if (this.myInputVariable != null) {

      this.myInputVariable.nativeElement.value = '';
    }

    this.DocumentID = 0;
  }


  fileToUpload: any;
  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
  }
  filemessage: any;
  DocumentID: any = 0;
  modifiedBy: any = '';
  afilename: any;
  IsReadOnly: any = true;
  SaveDocs() {
    this.adocauthor = this.userid;
    if (this.adocumentname && this.adocumentname.length > 0 && this.adocauthor && this.adocauthor.length > 0 &&
      ((this.fileToUpload != null && this.fileToUpload.size <= 2000000000) || (this.afilename && this.afilename.length > 0))) {
      //this.loaderservice.display(true);
      const endpoint = serviceUrl + '/ProjectDocuments/SaveProjectFileUploadDocs';
      const formData: FormData = new FormData();
      if (this.fileToUpload != null) {
        formData.append('fileKey', this.fileToUpload, this.fileToUpload.name);
      }
      formData.append('DocAuthor', this.adocauthor);
      formData.append('DocumentName', this.adocumentname);
      formData.append('FileName',
        this.DocumentID === 0 && this.fileToUpload != null ? this.fileToUpload.name : this.afilename);
      formData.append('ProjectNumber', this.projectnumber);
      formData.append('PublicAccess', this.ispublicAccessible);
      formData.append('ModifiedBy', this.userid);
      formData.append('DocumentID', this.DocumentID);
      formData.append('ProjectID', this.id);
      this.http
        .post(endpoint, formData)
        .subscribe(() => {
          this.dmessage = 'Successfully saved';
          this.acdclear();
          // this.loaderservice.display(false);
          this.getprojectdocumentallinfo();
        },
          err => {
            // const error = this.utility.ProcessError(err);
            // const i = 0;
            // if (error === 'Session Expired.') {
            //   setTimeout(() => {
            //     this.ExtendToken('SaveDocs', null);
            //   }, 100);
            // } else {
            //   this.loaderservice.display(false);
            // }
          });
      // .catch((e) => console.log(e));
    }
    else {
      if ((this.adocumentname && this.adocumentname.length == 0) ||
        (this.adocauthor && this.adocauthor.length == 0) || (this.adocumentname == undefined || this.adocumentname == "")
        || (this.adocauthor == undefined || this.adocauthor == "")
        || this.fileToUpload == null) {
        this.dmessage = "Please enter required fields"
      }
      else {
        this.dmessage = "";
      }

      if (this.fileToUpload != null && this.fileToUpload.size > 2000000000) {
        this.filemessage = 'File is too large to upload';
      }
      else {
        this.filemessage = "";
      }
    }

  }


  wholesetDone() {

  }

  editprojectdocumentItem(item) {
    // console.log(item);
    this.adocumentname = item.DocumentName;
    this.afilename = item.FileName;
    this.ispublicAccessible = item.PublicAccess;
    this.DocumentID = item.DocumentID;
  }

  deleteprojectdocs(row) {
    const index = -1;
    if (confirm('Do you want to delete selected Project Document?')) {
      // console.log("OK!");
      const hdrs = new HttpHeaders(
        { 'Content-type': 'application/json' });
      this.http.post<any>(serviceUrl + '/ProjectDocuments/DeleteProjectDocuments', {
        ProjectNumber: this.projectnumber,
        DocumentID: row.DocumentID,
        FileName: row.FileName
      }, { headers: hdrs }).subscribe(
        res => {
          // console.log(res)
          //this.loaderservice.display(false);
          this.getprojectdocumentallinfo();

        },
        err => {
          //   console.log("Error Occurred");
          // this.message = this.utility.ProcessError(err);
          //  if (this.message === 'Session Expired.') {
          //  this.message = '';
          //  setTimeout(() => {
          //    this.ExtendToken('deletecdocs', row);
          //   }, 100);
          //   } else {
          // this.loaderservice.display(false);
          //  }
        });

    } else {
      // console.log("Cancel!");
    }

  }


}
